import { useLocation, useNavigate } from "react-router-dom";

import Hamburger from "./Hamburger";
import HelpfulLinks from "./HelpfulLinks";
import Icon from "@components/Icon";
import T from "@components/translations/Translations";

import { GUARDIAN_DASHBOARD } from "@utils/auth/config";
import { useGlobalContext } from "@components/contextProvider/ContextProvider";
import { useSetAllLocationDtos } from "@components/contextProvider/ContextSetter";
import { logout } from "@utils/auth/Auth";

import "@/styles/Header.scss";

const Header = (): JSX.Element => {
    useSetAllLocationDtos();

    const { state } = useGlobalContext();
    const userDetails = state?.userDetails;

    const location = useLocation();
    const navigate = useNavigate();

    const { givenName, surname } = userDetails || {};

    const dashboard = (): void => {
        navigate("/guardian/home");
    };
    const dashboardKeyDown = (e: React.KeyboardEvent): void => {
        if (e.key?.toLowerCase() === "enter") navigate("/guardian/home");
    };

    const logoutKeyDown = (e: React.KeyboardEvent): void => {
        if (e.key?.toLowerCase() === "enter") logout();
    };

    return (
        <nav className="header-container">
            <div className="header-left">
                <div>
                    <a
                        aria-label="Guardian Dashboard Page Link"
                        href={GUARDIAN_DASHBOARD}
                        onClick={() => {
                            sessionStorage.clear();
                            return true;
                        }}
                        style={{
                            textDecoration: "none",
                            color: "black"
                        }}
                        target="_self"
                        tabIndex={0}
                    >
                        <Icon
                            style={{ marginTop: "15px" }}
                            fill="#19608f"
                            height={120}
                            iconName="DOUGLAS_COUNTY_SCHOOL_DISTRICT"
                            width={120}
                        />
                    </a>
                </div>
                <div className="header-name-container">
                    <p className="header-name">
                        <T tKey="Main_Nav_Welcome" /> {givenName} {surname}
                    </p>
                </div>
            </div>
            <div className="header-right">
                <div className="nav-button-container">
                    <HelpfulLinks />
                    {location?.pathname.includes("archive") && (
                        <button
                            aria-label="Dashboard Button"
                            className="btn btn-primary m-2 color-override"
                            onClick={dashboard}
                            onKeyDown={dashboardKeyDown}
                            type="button"
                        >
                            <span className="nav-button-text">
                                <T tKey="Global_Dashboard" />
                            </span>
                        </button>
                    )}

                    <button
                        aria-label="Logout Button"
                        className="btn btn-primary m-2 color-override"
                        onClick={logout}
                        onKeyDown={logoutKeyDown}
                        type="button"
                    >
                        <span className="nav-button-text">
                            <T tKey="Main_Nav_LogOut" />
                        </span>
                    </button>
                </div>
                <div className="mobile-hamburger">
                    <Hamburger />
                </div>
            </div>
        </nav>
    );
};

export default Header;
